<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col
            cols="12"
            md="5"

          >
            <v-card
              class="pa-5"
              min-height="300"
            >
              <v-card-text>
                <div class="text-center">
                  <v-icon
                    class="send-outlined"
                    color="primary"
                  >
                    send
                  </v-icon>
                </div>

              </v-card-text>
              <v-card-text v-if="!isSent">

                <div class="text-center">


                  <div class="display-1">Almost done!</div><br />

                  <div class="text-left">
                    The email associated with your {{ companyName() }} account needs to be confirmed. <br /><br />
                    We can send <u>{{ authEmail }}</u> a quick verification link.<br />
                    <br />
                  </div>

                </div>

                <v-btn
                  :loading="isLoading"
                  :disabled="isLoading"
                  block
                  rounded
                  outlined
                  color="primary"
                  @click="doSendEmailVerification()"
                >
                  Send verification email
                </v-btn>
              </v-card-text>
              <v-card-text v-if="isSent">
                <div class="text-center display-1">Email sent!</div>
              </v-card-text>

            </v-card>
            <div class="text-center">
              <v-btn
                text
                rounded
                small
                color="primary"
                class="mt-3"
                @click="doLogout()"
              >
                Logout
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>
<style>
  .v-icon.send-outlined {
    border: 1px solid;
    color: var(--v-primary-base);
    border-radius:50%;
    height: 125px;
    width: 125px;
    font-size: 60px;
  }
</style>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([ 'getAuthUser', 'isEmailVerified' ]),
    authEmail() {
      return this.getAuthUser.email
    }
  },
  mounted() {
    if (this.isEmailVerified) {
      this.$router.push({ name: 'admin-home' })
    }
  },
  data() {
    return {
      isSent: false,
      isLoading: false
    }
  },
  methods: {
    ...mapActions([ 'sendVerifyEmail', 'logout' ]),
    doLogout() {
      this.logout()
    },
    doSendEmailVerification() {
      this.isLoading = true
      this.sendVerifyEmail()
        .then(res => {
          this.isLoading = false
          this.isSent = true
        })
    },
    companyName() {
      return process.env.VUE_APP_COMPANY_NAME
    }
  }
}
</script>
